// import React, { useState } from 'react';
// import './ItemFilter.css';


// const categories = [
//   { name: 'סת"ם' },
//   { name: 'ריהוט' },
//   { name: 'שוטף' },
//   { name: 'ספרים' },
//   { name: 'אחר' },
// ];

// const ItemFilter = ({ onFilter }) => {
//   const [filterData, setFilterData] = useState({
//     category: [],
//     name: '',
//     relevant: ''
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     const updatedFilterData = { ...filterData, [name]: value };
//     setFilterData(updatedFilterData);
//     onFilter(updatedFilterData);
//   };

//   const handleCategoryChange = (category) => {
//     const newCategories = filterData.category.includes(category)
//       ? filterData.category.filter(cat => cat !== category)
//       : [...filterData.category, category];

//     const updatedFilterData = { ...filterData, category: newCategories };
//     setFilterData(updatedFilterData);
//     onFilter(updatedFilterData);
//   };

//   return (
//     <form className="item-filter">
//       <div className="category-buttons">
//         {categories.map((cat) => (
//           <label key={cat.name} className="category-button">
//             <input
//               type="checkbox"
//               name="category"
//               value={cat.name}
//               checked={filterData.category.includes(cat.name)}
//               onChange={() => handleCategoryChange(cat.name)}
//             />
//             <div id='filterOption'>
//               {cat.name}
//             </div>
//             {/* <span>{cat.name}</span> */}
//           </label>
//         ))}
//       </div>
//       <input type="text" name="name" placeholder="חיפוש לפי שם" onChange={handleChange} />
//       {/* <select name="relevant" onChange={handleChange}>
//         <option value="">מודעות רלוונטיות</option>
//         <option value="true">רלוונטי</option>
//         <option value="false">לא רלוונטי </option>
//       </select> */}
//     </form>
//   );
// };

// export default ItemFilter;


import React, { useState } from 'react';
import ConditionsModal from './ConditionsModal';
import './ItemFilter.css';

const categories = [
  { name: 'סת"ם' },
  { name: 'ריהוט' },
  { name: 'שוטף' },
  { name: 'ספרים' },
  { name: 'אחר' },
];

const ItemFilter = ({ onFilter }) => {
  const [filterData, setFilterData] = useState({
    category: [],
    name: '',
    relevant: ''
  });
  const [showModal, setShowModal] = useState(false); // Initially show the modal

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedFilterData = { ...filterData, [name]: value };
    setFilterData(updatedFilterData);
    onFilter(updatedFilterData);
  };

  const handleAcceptConditions = () => {
    setShowModal(false);
  };

  const handleAcceptConditionsTrue = () => {
    setShowModal(true);
  };

  const handleCategoryChange = (category) => {
    const newCategories = filterData.category.includes(category)
      ? filterData.category.filter(cat => cat !== category)
      : [...filterData.category, category];

    const updatedFilterData = { ...filterData, category: newCategories };
    setFilterData(updatedFilterData);
    onFilter(updatedFilterData);
  };

  return (
    <div className="item-filter">
      {showModal && <ConditionsModal onAccept={handleAcceptConditions} />}
      <div className="category-buttons">
        {categories.map((cat) => (
          <label
            key={cat.name}
            className={`category-button ${filterData.category.includes(cat.name) ? 'selected' : ''}`}
          >
            <input
              type="checkbox"
              name="category"
              value={cat.name}
              checked={filterData.category.includes(cat.name)}
              onChange={() => handleCategoryChange(cat.name)}
            />
            <div id="filterOption">
              {cat.name}
            </div>
          </label>
        ))}
      </div>
      <div className="filter-row" style={{ width: '70%' }}>
        <input type="text" name="name" placeholder="חיפוש לפי שם" onChange={handleChange} />
        <button name="relevant" onClick={handleAcceptConditionsTrue}>
          תקנון
        </button>
      </div>
    </div>
  );
};

export default ItemFilter;
